import React, { useState, useEffect } from 'react';
import axios from 'axios';

//const API = process.env.REACT_APP_API_URL || 'https://sohaibenterprises.cloud/api';
const API = 'http://localhost:5000/api';
const SuppliersTab = () => {
  const [suppliers, setSuppliers]   = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showForm, setShowForm]     = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [formData, setFormData]     = useState({ name: '', phone: '', address: '' });
  const [saving, setSaving]         = useState(false);
  const [error, setError]           = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  // ── Fetch all suppliers ──
  const fetchSuppliers = async () => {
    try {
      const res = await axios.get(`${API}/tape/suppliers`, { headers });
      setSuppliers(res.data.data || []);
    } catch {
      setError('Failed to load suppliers');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchSuppliers(); }, []);

  // ── Open form for new supplier ──
  const handleAdd = () => {
    setEditingItem(null);
    setFormData({ name: '', phone: '', address: '' });
    setShowForm(true);
    setError('');
  };

  // ── Open form for editing existing supplier ──
  const handleEdit = (supplier) => {
    setEditingItem(supplier);
    setFormData({ name: supplier.name, phone: supplier.phone || '', address: supplier.address || '' });
    setShowForm(true);
    setError('');
  };

  // ── Save (create or update) ──
  const handleSave = async () => {
    if (!formData.name.trim()) {
      setError('Supplier name is required');
      return;
    }
    setSaving(true);
    try {
      if (editingItem) {
        await axios.put(`${API}/tape/suppliers/${editingItem.id}`, formData, { headers });
      } else {
        await axios.post(`${API}/tape/suppliers`, formData, { headers });
      }
      setShowForm(false);
      fetchSuppliers();
    } catch {
      setError('Failed to save supplier');
    } finally {
      setSaving(false);
    }
  };

  // ── Delete supplier ──
  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this supplier?')) return;
    try {
      await axios.delete(`${API}/tape/suppliers/${id}`, { headers });
      fetchSuppliers();
    } catch {
      setError('Failed to delete supplier');
    }
  };

  if (loading) return <div style={{ textAlign: 'center', padding: '60px', color: '#7f8c8d' }}>Loading suppliers...</div>;

  return (
    <div>
      {/* ── HEADER ── */}
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
        <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#2c3e50', margin: 0 }}>
          🏭 Suppliers
        </h2>
        <button
          onClick={handleAdd}
          style={{
            padding: '12px 24px', background: '#f39c12', border: 'none',
            borderRadius: '10px', color: 'white', cursor: 'pointer',
            fontSize: '14px', fontWeight: '600'
          }}
        >
          + Add Supplier
        </button>
      </div>

      {/* ── ERROR MESSAGE ── */}
      {error && (
        <div style={{ background: '#fdecea', border: '1px solid #e74c3c', borderRadius: '10px', padding: '12px 16px', marginBottom: '20px', color: '#e74c3c' }}>
          {error}
        </div>
      )}

      {/* ── ADD / EDIT FORM ── */}
      {showForm && (
        <div style={{
          background: 'white', borderRadius: '16px', padding: '24px',
          boxShadow: '0 4px 15px rgba(0,0,0,0.08)', marginBottom: '24px',
          border: '2px solid #f39c12'
        }}>
          <h3 style={{ fontSize: '18px', fontWeight: '700', color: '#2c3e50', marginBottom: '20px' }}>
            {editingItem ? 'Edit Supplier' : 'Add New Supplier'}
          </h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>
                Supplier Name *
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={e => setFormData({ ...formData, name: e.target.value })}
                placeholder="e.g. Ali Traders"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>
                Phone
              </label>
              <input
                type="text"
                value={formData.phone}
                onChange={e => setFormData({ ...formData, phone: e.target.value })}
                placeholder="e.g. 0300-1234567"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#555', marginBottom: '6px' }}>
                Address
              </label>
              <input
                type="text"
                value={formData.address}
                onChange={e => setFormData({ ...formData, address: e.target.value })}
                placeholder="e.g. Lahore, Pakistan"
                style={{ width: '100%', padding: '10px 14px', border: '1px solid #ddd', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
              />
            </div>
          </div>
          <div style={{ display: 'flex', gap: '12px', marginTop: '20px' }}>
            <button
              onClick={handleSave}
              disabled={saving}
              style={{ padding: '10px 24px', background: '#f39c12', border: 'none', borderRadius: '8px', color: 'white', cursor: 'pointer', fontWeight: '600' }}
            >
              {saving ? 'Saving...' : (editingItem ? 'Update' : 'Save')}
            </button>
            <button
              onClick={() => setShowForm(false)}
              style={{ padding: '10px 24px', background: '#f0f0f0', border: 'none', borderRadius: '8px', color: '#555', cursor: 'pointer', fontWeight: '600' }}
            >
              Cancel
            </button>
          </div>
        </div>
      )}

      {/* ── SUPPLIERS TABLE ── */}
      <div style={{ background: 'white', borderRadius: '16px', padding: '24px', boxShadow: '0 4px 15px rgba(0,0,0,0.08)' }}>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#f8f9fa' }}>
                {['#', 'Name', 'Phone', 'Address', 'Added On', 'Actions'].map(h => (
                  <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: '13px', color: '#7f8c8d', fontWeight: '600' }}>
                    {h}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {suppliers.map((supplier, index) => (
                <tr key={supplier.id} style={{ borderBottom: '1px solid #f0f0f0', background: index % 2 === 0 ? 'white' : '#fafafa' }}>
                  <td style={{ padding: '12px 16px', color: '#7f8c8d' }}>{index + 1}</td>
                  <td style={{ padding: '12px 16px', fontWeight: '600', color: '#2c3e50' }}>{supplier.name}</td>
                  <td style={{ padding: '12px 16px', color: '#555' }}>{supplier.phone || '-'}</td>
                  <td style={{ padding: '12px 16px', color: '#555' }}>{supplier.address || '-'}</td>
                  <td style={{ padding: '12px 16px', color: '#7f8c8d' }}>{new Date(supplier.created_at).toLocaleDateString()}</td>
                  <td style={{ padding: '12px 16px' }}>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <button
                        onClick={() => handleEdit(supplier)}
                        style={{ padding: '6px 14px', background: '#3498db', border: 'none', borderRadius: '6px', color: 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(supplier.id)}
                        style={{ padding: '6px 14px', background: '#e74c3c', border: 'none', borderRadius: '6px', color: 'white', cursor: 'pointer', fontSize: '13px', fontWeight: '600' }}
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
              {suppliers.length === 0 && (
                <tr>
                  <td colSpan="6" style={{ padding: '40px', textAlign: 'center', color: '#7f8c8d' }}>
                    No suppliers added yet. Click "Add Supplier" to get started.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SuppliersTab;